/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBorderCornerSquare = createReactComponent(
  "border-corner-square",
  "IconBorderCornerSquare",
  [["path", { d: "M4 20v-15a1 1 0 0 1 1 -1h15", key: "svg-0" }]]
);

export { IconBorderCornerSquare as default };
//# sourceMappingURL=IconBorderCornerSquare.js.map
